/** @module csi/widget/_svg/CopyPage */
define([
	"dijit/form/Button",
	"./_Plugin",
	"./PluginFactory",
	"./util",
], function(Button, _Plugin, PluginFactory, svgUtil) {

	return PluginFactory.declare([Button, _Plugin], {
		materialIcon: "content_copy",
		pluginName: "copyPage",
		title: "CanvasCopyPage",

		/**
		 * Click handler for CopyPage
		 * If canvas pages are at max, show error, otherwise, copy the page
		 */
		onClick: function() {
			const { editor } = this;
			const view = this.getView();
			if (view.hasMaxPages()) {
				// show max pages reached dialog
				svgUtil.popupMaxPageErrorMessage();
			} else {
				view.addPage(editor.preparePageForCopy());
			}
		}
	});
});